import { persisted } from '@square/svelte-store'

export const currentLocale = persisted(null, 'lang', { reloadable: true })
